import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle, Home, Mail } from 'lucide-react';

export const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>
          <CardTitle className="text-2xl text-green-600">
            Paiement Réussi !
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <div>
            <p className="text-gray-600 mb-2">
              Merci pour votre confiance !
            </p>
            <p className="text-gray-600">
              Votre paiement a été traité avec succès. Vous recevrez une confirmation par email sous peu.
            </p>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
            <h3 className="font-semibold text-gray-900 mb-2">Prochaines étapes :</h3>
            <ul className="text-sm text-gray-600 space-y-1 text-left">
              <li>✅ Nous avons bien reçu votre paiement</li>
              <li>✅ Un email de confirmation vous sera envoyé</li>
              <li>✅ Notre équipe va préparer votre commande</li>
              <li>✅ Nous vous contacterons pour la livraison</li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold"
            >
              <Home className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
            <Button
              variant="outline"
              onClick={() => window.location.href = 'mailto:contact@znsolar.fr'}
            >
              <Mail className="w-4 h-4 mr-2" />
              Nous contacter
            </Button>
          </div>

          <div className="pt-6 border-t">
            <p className="text-sm text-gray-500">
              <strong>Z&N Solar</strong> - L'excellence sans compromis
              <br />
              📞 06 23 73 77 80 | ✉️ contact@znsolar.fr
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
